import { useCustomerViewSate } from "api/admin/customerView";
import { useEffect } from "react";
import { FaTools } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function UnderMaintenance() {
  const { data, isSuccess, isLoading } = useCustomerViewSate();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess && !isLoading) {
      if (!data.maintenance) navigate("/cp");
    }
  }, [data]);

  return (
    <div className="h-full flex flex-col items-center justify-center_ pt-40 text-center px-4 text-white">
      <div className="text-mainLight mb-6">
        <FaTools size={200} />
      </div>

      <h1 className="text-4xl font-bold mb-4 text-mainLight">
        التطبيق قيد الصيانة
      </h1>
    </div>
  );
}
